import { render, staticRenderFns } from "./SimplePoll.vue?vue&type=template&id=7fc004b8&"
import script from "./SimplePoll.vue?vue&type=script&lang=js&"
export * from "./SimplePoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports